import { productCardStyles } from "@insite/content-library/Widgets/ProductList/ProductListProductCard";
import { css } from "styled-components";

productCardStyles.rightColumnGridItem = {
    width: [8, 8, 8, 9, 9],
    css: css`
        background: #f8f8f8;
        div[class^="GridOffset"] {
            width: 100%;
        }
    `,
};

productCardStyles.gridContainer = {
    gap: 0,
    css: css`
        padding: 30px 0;
        min-width: 320px; /* prevent overlap with second column */
        border-bottom: 1px solid #cccccc;
        [data-test-selector^="quantityBreakPricingLink"] {
            span {
                font-size: 14px;
                color: #000;
            }
        }
    `,
};
